import { render, staticRenderFns } from "./characterModalMobile.vue?vue&type=template&id=20a752b5&scoped=true&"
import script from "./characterModalMobile.vue?vue&type=script&lang=js&"
export * from "./characterModalMobile.vue?vue&type=script&lang=js&"
import style0 from "./characterModalMobile.vue?vue&type=style&index=0&id=20a752b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a752b5",
  null
  
)

export default component.exports